import React, { useState } from "react";

import { ClickAwayListener } from "@material-ui/core";
import { mostrarDropdownDeTelas } from "../../../Validations/UsuarioTela";
import { useUserInfor } from "../../../Context/User";

interface ISubNavDropDownProps {
    children: React.ReactNode;
    title: string;
    telas: Array<number>;
}

export default function SubNavDropDown(props: ISubNavDropDownProps) {
    const { UserInfor } = useUserInfor();
    const [showDropdown, setshowDropdown] = useState("");

    return (
        <>
            {mostrarDropdownDeTelas(props.telas, UserInfor.TELAS) && (
                <ClickAwayListener
                    mouseEvent="onMouseDown"
                    touchEvent="onTouchEnd"
                    onClickAway={() => {
                        setshowDropdown("");
                    }}
                >
                    <li
                        className={`menu-item menu-item-submenu ${showDropdown}`}
                    >
                        <span
                            className="menu-link menu-toggle"
                            onClick={() => {
                                if (
                                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                        navigator.userAgent
                                    )
                                ) {
                                    if (
                                        document.getElementsByClassName(
                                            "menu-item-open menu-item-open-dropdown menu-item-hover"
                                        ).length > 0
                                    )
                                        setshowDropdown("");
                                    else
                                        setshowDropdown(
                                            "menu-item-open menu-item-open-dropdown menu-item-hover"
                                        );
                                } else {
                                    if (
                                        document.getElementsByClassName(
                                            "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                        ).length > 0
                                    )
                                        setshowDropdown("");
                                    else
                                        setshowDropdown(
                                            "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                        );
                                }
                            }}
                        >
                            <span className="menu-text">{props.title}</span>
                            <span className="menu-desc"></span>
                            <i className="menu-arrow"></i>
                        </span>

                        <div className="menu-submenu menu-submenu-classic menu-submenu-left">
                            <ul className="menu-subnav">{props.children}</ul>
                        </div>
                    </li>
                </ClickAwayListener>
            )}
        </>
    );
}
